export default {
    alphanumeric: /(\p{Alphabetic}|[0-9])+/gu
};
